import React from 'react'
import { connect } from 'react-redux'
import toLower from 'lodash/toLower'

import Modal from 'react-responsive-modal'
import FormChangeBanner from '../../Containers/Attraction/FormChangeBanner'

import AttractionActions from '../../Redux/AttractionRedux'

class AttractionUpdate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      tab: null,
      form: {
        language_code: toLower(props.setting.language_code),
        highlights: '',
        additional_info: '',
        description: ''
      },
      files: {},
      showModal: null,
      selected: {
        item: {},
        dimension: null,
        banner: null
      }
    }
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      form: {
        ...this.state.form,
        highlights: nextProps.attraction.detail.highlights,
        additional_info: nextProps.attraction.detail.additional_info,
        description: nextProps.attraction.detail.description
      }
    })
  }

  componentDidMount = () => {
    let filter = {
      language_code: this.props.setting.language_code,
      currency_code: this.props.setting.currency_code
    }
    let data = {
      id: this.props.detailId,
      filter
    }
    this.props.getAttractionDetail(data)
  }

  _toggleModal = (modalId = null, item, dimension) => {
    this.setState({
      showModal: modalId,
      selected: {
        ...this.state.selected,
        item,
        dimension
      }
    })

    this.props.closeModal()
  }

  _toggleTab = (tabName = null) => {
    this.setState({
      tab: tabName
    })
  }

  _inputChange = (event, field) => {
    const val = event.target.value
    let newState = {...this.state}
    newState['form'][field] = val
    this.setState({ newState })
  }

  _fileSelect = (event, item, dimension) => {
    let reader = new FileReader()
    let file = event.target.files[0]
    let newImage = {...this.state.files}

    reader.onloadend = () => {
      newImage[item.uuid + dimension] = reader.result
      this.setState({
        files: newImage
      })
    }

    reader.readAsDataURL(file)
  }

  _submit = () => {
    const form = this.state.form
    const data = {
      id: this.props.attraction.detail.id,
      form
    }
    this.props.updateAttractionDetail(data)
    this.props.closeModal()
  }

  _toggleChangeBanner = (modalId = null, bannerType = 'wide') => {
    this.setState({
      showModal: modalId,
      selected: {
        ...this.state.selected,
        banner: bannerType
      }
    })
  }

  render () {
    const { detail, fetching, err, processing } = this.props.attraction
    // const { files } = this.state
    return (
      <div className='section' style={{ width: '75vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>
            Update Attraction Banner
            {(fetching || processing) && <div className='badge badge-info ml-2'>{fetching ? 'Loading' : 'Processing'} ...</div>}
          </h4>
        </div>
        {err && <div className='alert alert-danger'>{err}</div>}

        <div className='row'>
          <div className='form-group col-6 text-center'>
            <label className='control-label'>Web (<span className='text-orange'>1049x433</span>)</label>
            <div>
              {(detail.banner_url && detail.banner_url.wide)
                ? <img src={detail.banner_url.wide} alt='' className='img img-responsive mb-2' style={{width: '100%'}} />
                : <strong>- NO IMAGE -</strong>
              }
            </div>
            <button className='btn btn-primary' onClick={() => this._toggleChangeBanner('change-banner', 'wide')}>Change Banner</button>
          </div>

          <div className='form-group col-6 text-center'>
            <label className='control-label'>Mobile (<span className='text-orange'>375x269</span>)</label>
            <div>
              {(detail.banner_url && detail.banner_url.wide_mobile)
                ? <img src={detail.banner_url.wide_mobile} alt='' className='img img-responsive mb-2' style={{width: '100%'}} />
                : <div>
                  <strong>- NO IMAGE -</strong><br />
                  <p>
                    <strong>
                      * Image for mobile banner will take from web banner image
                    </strong>
                  </p>
                </div>
              }
            </div>
            <button className='btn btn-primary' onClick={() => this._toggleChangeBanner('change-banner', 'wide_mobile')}>Change Banner</button>
          </div>

          <Modal open={this.state.showModal === 'change-banner'} onClose={this._toggleModal} closeOnOverlayClick>
            <FormChangeBanner attractionId={this.props.detailId} banners={detail.banner_file} bannerType={this.state.selected.banner} closeModal={() => this._toggleModal()} />
          </Modal>
        </div>
        <div className='form-group d-flex justify-content-end'>
          <button className='btn btn-lg btn-secondary' onClick={() => this.props.closeModal()}>Close</button>
        </div>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  attraction: state.attraction,
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  getAttractionDetail: (data) => dispatch(AttractionActions.attractionDetailRequest(data)),
  updateAttractionDetail: (data) => dispatch(AttractionActions.attractionUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(AttractionUpdate)



// WEBPACK FOOTER //
// ./src/Containers/Attraction/FormUpdateBanner.js